import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { GarminSettingsPage } from './GarminSettingsPage'

export const routes: RouteObject[] = [{ path: '/settings/garmin', element: <GarminSettingsPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/garmin', label: 'Garmin', icon: 'activity', mobile: null, order: 10, parent: '/settings' },
]
